import { createI18n } from 'vue-i18n'
import storage from '@/plugins/storage'
import { localeOptions } from '@/constants/locale/config'
import en from '@/constants/locale/en'
import tc from '@/constants/locale/tc'

const langaugeMap = lang => (
  !lang ? 'tc' :
  !lang.includes('zh') ? 'tc' :
  // !lang.includes('ja') ? 'ja' :
  'en'
)

const getLocale = () => {
  let locale = storage.get('locale')
  return localeOptions.some(option => option.value === locale) ? locale : langaugeMap(window.navigator.language || navigator.userLanguage)
}

export default createI18n({
  locale: getLocale(),
  fallbackLocale: 'en',
  messages: { en, tc }
})